import DeleteIcon from '@mui/icons-material/Delete';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { LoadingButton, Modal } from '../../components';
import actions from '../../modules/sites';
import messages from './messages';

export default function DeleteSiteModal() {
  const dispatch = useDispatch();
  const site = useSelector((state) => state.sites.deleteModal.site);
  const open = useSelector((state) => state.sites.deleteModal.show);
  const isFetching = useSelector((state) => state.sites.deleteModal.isFetching);

  return (
    !!open && (
      <Modal
        actions={
          <div>
            <Button onClick={() => dispatch(actions.deleteSiteHideModal())}>
              <FormattedMessage {...messages.deleteSiteModalCancel} />
            </Button>
            <LoadingButton
              color="error"
              disabled={isFetching}
              isLoading={isFetching}
              onClick={() => dispatch(actions.deleteSiteConfirm(site))}
              startIcon={<DeleteIcon />}
              variant="outlined"
            >
              <FormattedMessage {...messages.deleteSiteModalConfirm} />
            </LoadingButton>
          </div>
        }
        headerVariant="danger"
        maxWidth="xs"
        name="delete-site-modal"
        onClose={() => dispatch(actions.deleteSiteHideModal())}
        open={open}
        title={<FormattedMessage values={{ siteName: site.name }} {...messages.deleteSiteModalTitle} />}
      >
        <Typography>
          <FormattedMessage {...messages.deleteSiteModalDescriptionTitle} />
        </Typography>
        <ul>
          <Typography component="li">
            <FormattedMessage {...messages.deleteSiteModalDescriptionListOneItem} />
          </Typography>
          <Typography component="li">
            <FormattedMessage {...messages.deleteSiteModalDescriptionListTwoItem} />
          </Typography>
          <Typography component="li">
            <FormattedMessage {...messages.deleteSiteModalDescriptionListThreeItem} />
          </Typography>
        </ul>
        <Typography>
          <FormattedMessage {...messages.deleteSiteModalDescriptionBottom} />
        </Typography>
      </Modal>
    )
  )
}
